<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>
                 <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            dataField="ciclo"
                            caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                            dataField="periodoevaluacion"
                            caption="Descripcion">
                        </dxi-column>
                        <dxi-column
                            dataField="departamento"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            dataField="nombre"
                            caption="Colaborador">
                        </dxi-column>

                        <dxi-column
                            [allowExporting]="false"
                            caption="Colaboradores"
                            cellTemplate="cellAccionescolaboradores"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Estudiantes preescolar y primaria"
                            cellTemplate="cellAccionesalumnoskyp"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Estudiantes"
                            cellTemplate="cellAccionesalumnos"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Padres de familia"
                            cellTemplate="cellAccionespadres"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Talleres extracurriculares - Estudiantes"
                            cellTemplate="cellAccionestalleralumno"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Talleres extracurriculares - Padres de familia"
                            cellTemplate="cellAccionestallerpadres"
                            alignment="center"
                            [minWidth]="120">
                        </dxi-column>

                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAccionescolaboradores'">
                            <a *ngIf="cell.data.vercolaborador == 1" matTooltip="Ver" class="tablaBoton" (click)="Formulario(1, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionesalumnoskyp'">
                            <a *ngIf="cell.data.verpre == 1" matTooltip="Ver" class="tablaBoton" (click)="Formulario(4, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionesalumnos'">
                            <a *ngIf="cell.data.verestudiantes == 1" matTooltip="Ver" class="tablaBoton" (click)="Formulario(3, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionespadres'">
                            <a *ngIf="cell.data.verpadres == 1" matTooltip="Ver" class="tablaBoton" (click)="Formulario(2, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionestalleralumno'">
                          <a *ngIf="cell.data.verpadrestaller == 1" matTooltip="Ver" class="tablaBoton" (click)="Formulario(5, cell.data)">
                              <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div *dxTemplate="let cell of 'cellAccionestallerpadres'">
                          <a *ngIf="cell.data.verestudiantestaller == 1" matTooltip="Ver" class="tablaBoton" (click)="Formulario(6, cell.data)">
                              <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                          </a>
                        </div>
                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #preguntasenviadasdetalle></div>
